import React from 'react'
import "./Invitation_Record.css"
import Common_white_header from '../Common/Common_Component/Common_white_header/Common_white_header'
import No_data from '../Common/No_data/No_data'

function Invitation_Record() {

  const records = [
    {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },

      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
      {
      id: 1,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 2,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
    {
      id: 3,
      member: "NNHSGD1R",
      uid: "11812876",
      registrationTime: "2025-07-04 15:52:23",
      depositAmount: "₹200.00"
    },
  ]

  return (
    <>
      <section className='Invitation_Record'>
        <Common_white_header headingText={"Invitation Record"} />

        <div className='container'>
          <div className='invitation_record_list'>

            {records.map((item) => (
              <div className='invitation_card' key={item.id}>

                {/* Top Row */}
                <div className='invitation_card_top'>
                  <div className='member_name'>
                    Member {item.member}
                  </div>

                  <div className='member_uid'>
                    UID:{item.uid}
                  </div>
                </div>

                {/* Bottom Row */}
                <div className='invitation_card_bottom'>

                  <div className='left_section'>
                    <div className='label'>Registration time</div>
                    <div className='value'>{item.registrationTime}</div>
                  </div>

                  <div className='right_section'>
                    <div className='label'>Deposit amount</div>
                    <div className='amount'>{item.depositAmount}</div>
                  </div>

                </div>

              </div>
            ))}

          </div>

             <No_data/>
        </div>
      </section>
    </>
  )
}

export default Invitation_Record